export const BillingPlanIds = Object.freeze({
  Trial: 0,
  UpsCtpLight: 15,
  UpsCtpSmall: 16,
  UpsCtpMedium: 17,
  UpsCtpLarge: 18,
  SquareStarter: 21,
  StampsDesktop: 22,
  Starter2019: 23,
  YahooFree: 24,
  YahooStarter: 25,
  YahooBronze: 26,
  YahooSilver: 27,
  FreePostal: 30,
  FreeStarter: 31,
  SSEnterpriseUK: 42,
  SSStartupAU: 44,
  SSAccelerateAU: 45,
  SSScaleAU: 46,
  SSEnterpriseAU: 47,
  Starter2022Q2: 52,
  Starter2022Q3Grandfathered: 59,
  Starter2022Q3: 66,
  Starter2022Q3NonWalleted: 166,
  Bronze2022Q3NonWalleted: 167,
  Silver2022Q3NonWalleted: 168,
  Gold2022Q3NonWalleted: 169,
  Platinum2022Q3NonWalleted: 170,
  Enterprise2022Q4NonWalleted: 173,
  HighVolume2022Q3PlanId: 72,
  HighVolume2023Q2PlanId: 74,
  HighVolume2024_4PlanId: 75,
  HighVolume2024_45PlanId: 76,
  HighVolume2024_5PlanId: 77,
  HighVolume2024_35PlanId: 78,
  Bronze2022Q3: 67,
  Silver2022Q3: 68,
  Gold2022Q3: 69,
  Platinum2022Q3: 70,
  Enterprise2022Q4: 73,
  SSHighVolumeANZQ22023: 93,
  SSStartupANZQ12023: 94,
  SSAccelerateANZQ12023: 95,
  SSScaleANZQ12023: 96,
  SSEnterpriseANZQ12023: 97,
  SSUKEnterprise2023Q2: 112,
  SSEUStartupBYOA2023Q2: 113,
  SSEUAccelerateBYOA2023Q2: 114,
  SSEUScaleBYOA2023Q2: 115,
  SSUKStartupBYOA2023Q2: 117,
  SSUKAccelerateBYOA2023Q2: 118,
  SSUKScaleBYOA2023Q2: 119,
  Free2025Q2: 120,
  Starter2025Q2: 121,
  Standard2025Q2: 122,
  Premium2025Q2: 123,
  Starter2025Q2Annual: 124,
  Standard2025Q2Annual: 125,
  Premium2025Q2Annual: 126,
  UpsDcBasic: 128,
  UpsDcIntermediate: 129,
  UpsDcAdvanced: 130,
  UpsDcEnterprise: 131,
});

const UsageBilledHighVolumeBillingPlanIds = Object.freeze([
  BillingPlanIds.HighVolume2023Q2PlanId,
  BillingPlanIds.HighVolume2024_4PlanId,
  BillingPlanIds.HighVolume2024_45PlanId,
  BillingPlanIds.HighVolume2024_5PlanId,
  BillingPlanIds.HighVolume2024_35PlanId,
]);

export const isBillingPlanIdUsageBilledHighVolume = (billingPlanId) => {
  const parsed = parseInt(billingPlanId, 10);
  return UsageBilledHighVolumeBillingPlanIds.includes(parsed);
};

export const HighVolumePlanToUsagePriceMap = Object.freeze({
  [BillingPlanIds.HighVolume2023Q2PlanId]: 0.08,
  [BillingPlanIds.HighVolume2024_4PlanId]: 0.04,
  [BillingPlanIds.HighVolume2024_45PlanId]: 0.045,
  [BillingPlanIds.HighVolume2024_5PlanId]: 0.05,
  [BillingPlanIds.HighVolume2024_35PlanId]: 0.035,
});

export const BillingPlansThatIncludeNonWalletedAccess = Object.freeze([
  BillingPlanIds.Starter2022Q3NonWalleted,
  BillingPlanIds.Bronze2022Q3NonWalleted,
  BillingPlanIds.Silver2022Q3NonWalleted,
  BillingPlanIds.Gold2022Q3NonWalleted,
  BillingPlanIds.Platinum2022Q3NonWalleted,
  BillingPlanIds.Enterprise2022Q4NonWalleted,
  BillingPlanIds.HighVolume2023Q2PlanId,
  BillingPlanIds.HighVolume2024_4PlanId,
  BillingPlanIds.HighVolume2024_45PlanId,
  BillingPlanIds.HighVolume2024_5PlanId,
  BillingPlanIds.HighVolume2024_35PlanId,
]);

export const BillingPlansThatDoNotIncludeNonWalletedAccess = Object.freeze([
  BillingPlanIds.Starter2022Q3,
  BillingPlanIds.Bronze2022Q3,
  BillingPlanIds.Silver2022Q3,
  BillingPlanIds.Gold2022Q3,
  BillingPlanIds.Platinum2022Q3,
  BillingPlanIds.Enterprise2022Q4,
]);

export const BillingPlanPerLabelCharges = Object.freeze({
  [BillingPlanIds.SSStartupANZQ12023]: 0.22,
  [BillingPlanIds.SSAccelerateANZQ12023]: 0.13,
  [BillingPlanIds.SSScaleANZQ12023]: 0.08,
  [BillingPlanIds.SSEnterpriseANZQ12023]: 0.05,
  [BillingPlanIds.SSHighVolumeANZQ22023]: 0.05,

  // EU
  [BillingPlanIds.SSEUStartupBYOA2023Q2]: 0.05,
  [BillingPlanIds.SSEUAccelerateBYOA2023Q2]: 0.04,
  [BillingPlanIds.SSEUScaleBYOA2023Q2]: 0.03,

  // UK
  [BillingPlanIds.SSUKStartupBYOA2023Q2]: 0.05,
  [BillingPlanIds.SSUKAccelerateBYOA2023Q2]: 0.04,
  [BillingPlanIds.SSUKScaleBYOA2023Q2]: 0.03,
});

export const NZ_AU_BILLING_PLAN_IDS = [
  BillingPlanIds.SSStartupAU,
  BillingPlanIds.SSAccelerateAU,
  BillingPlanIds.SSScaleAU,
  BillingPlanIds.SSEnterpriseAU,
  BillingPlanIds.SSHighVolumeANZQ22023,
  BillingPlanIds.SSStartupANZQ12023,
  BillingPlanIds.SSAccelerateANZQ12023,
  BillingPlanIds.SSScaleANZQ12023,
  BillingPlanIds.SSEnterpriseANZQ12023,
]; // SPD-14474: remove these hard codes

export const BILLING_PLANS_UK_ENTERPRISE = [BillingPlanIds.SSEnterpriseUK, BillingPlanIds.SSUKEnterprise2023Q2];

export const UPS_CTP_BILLING_PLAN_IDS = [
  BillingPlanIds.UpsCtpLight,
  BillingPlanIds.UpsCtpSmall,
  BillingPlanIds.UpsCtpMedium,
  BillingPlanIds.UpsCtpLarge,
];

export const UPS_DC_BILLING_PLAN_IDS = [
  BillingPlanIds.UpsDcBasic,
  BillingPlanIds.UpsDcIntermediate,
  BillingPlanIds.UpsDcAdvanced,
  BillingPlanIds.UpsDcEnterprise,
];

export const BILLING_PLANS_GOODBETTERBEST_2025_Q2 = [
  BillingPlanIds.Free2025Q2,
  BillingPlanIds.Starter2025Q2,
  BillingPlanIds.Standard2025Q2,
  BillingPlanIds.Premium2025Q2,
  BillingPlanIds.Starter2025Q2Annual,
  BillingPlanIds.Standard2025Q2Annual,
  BillingPlanIds.Premium2025Q2Annual,
  BillingPlanIds.Trial,
];

export const BILLING_PLANS_PREMIUM = [BillingPlanIds.Premium2025Q2.toString(), BillingPlanIds.Premium2025Q2Annual.toString()];
